module.exports = __webpack_public_path__ + "static/media/60.2a3d5c51.jpg";